import React from "react";

interface LoadingSkeletonProps {
  showOptions: boolean;
}

const LoadingSkeletonItem: React.FC<{ showOptions: boolean }> = ({ showOptions }) => (
  <div
    style={{
      backgroundColor: "#f7fafc",
      borderRadius: "12px",
      padding: "16px",
      border: "1px solid #e2e8f0",
      marginBottom: "12px",
    }}
  >
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
      <div style={{ flex: 1 }}>
        <div
          style={{
            height: "16px",
            width: "200px",
            backgroundColor: "#e2e8f0",
            borderRadius: "4px",
            marginBottom: "8px",
            animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
          }}
        />
        <div
          style={{
            height: "14px",
            width: "120px",
            backgroundColor: "#e2e8f0",
            borderRadius: "4px",
            marginBottom: "4px",
            animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
          }}
        />
        <div
          style={{
            height: "12px",
            width: "80px",
            backgroundColor: "#e2e8f0",
            borderRadius: "4px",
            animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
          }}
        />
      </div>
      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
        <div
          style={{
            height: "24px",
            width: "70px",
            backgroundColor: "#e2e8f0",
            borderRadius: "12px",
            animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
          }}
        />
        <div
          style={{
            height: "32px",
            width: "32px",
            backgroundColor: "#e2e8f0",
            borderRadius: "6px",
            animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
          }}
        />
      </div>
    </div>
    {showOptions && (
      <div
        style={{
          marginTop: "12px",
          paddingTop: "12px",
          borderTop: "1px solid #e2e8f0",
          display: "flex",
          gap: "16px",
        }}
      >
        <div
          style={{
            height: "20px",
            width: "80px",
            backgroundColor: "#e2e8f0",
            borderRadius: "4px",
            animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
          }}
        />
        <div
          style={{
            height: "20px",
            width: "120px",
            backgroundColor: "#e2e8f0",
            borderRadius: "4px",
            animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
          }}
        />
      </div>
    )}
  </div>
);

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ showOptions }) => (
  <>
    <style>
      {`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}
    </style>
    <div>
      <LoadingSkeletonItem showOptions={showOptions} />
      <LoadingSkeletonItem showOptions={showOptions} />
      <LoadingSkeletonItem showOptions={showOptions} />
    </div>
  </>
);

export default LoadingSkeleton; 